import React from "react";
import Slider from "react-slick";
import "../../stylesheet/components/scrolljackcontainer/ScrollSnapContainer.scss";

const ScrollSnapContainer: React.FC<{
	children: JSX.Element[];
}> = ({ children }) => {
	const SliderSettings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true
	};

	return (
		<>
			<div className="scroll-snap-outer">
				{children.map((child, index) => {
					return (
						<div key={index} className="scroll-snap-section">
							{child}
						</div>
					);
				})}
			</div>
			<div className="scroll-snap-outer__slider-container">
				<Slider {...SliderSettings} className="scroll-snap-outer__slider">
					{children.map((child, index) => {
						return (
							<div key={index} className="scroll-snap-section">
								{child}
							</div>
						);
					})}
				</Slider>
			</div>
		</>
	);
};

export default ScrollSnapContainer;
